export default {
    UserName: '请输入用户名！',
    Password: '请输入密码！',
    Email: '请输入邮箱！',
    Mobile: '请输入手机号码！',
    Captcha: '请输入验证码！'
};


// WEBPACK FOOTER //
// ./src/components/login/default_validate_message.js